var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs-head"},_vm._l((_vm.formatedTabs),function(ref){
var name = ref.name;
var value = ref.value;
return _c('label',{key:value,staticClass:"tab",class:{ active: _vm.active === value },on:{"click":function($event){_vm.$emit('update:active', value)}}},[_vm._v("\n    "+_vm._s(name)+"\n  ")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02c48d99","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/globals/TabsHead.vue
// module id = 420
// module chunks = 8